// noinspection SuspiciousTypeOfGuard

import TextField from "@mui/material/TextField";
import { AutocompleteProps } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import {
  type MRT_Column as MRTColumn,
  type MRT_TableInstance as MRTTableInstance
} from "material-react-table";
import { PermissionsByGranteeId } from "permissions/entities/permission/api/permissions-api-service";

type FilterOption = {
  label: string;
  value: string;
};

export function useAutocompleteFilterProps(
  columnId: string,
  options: FilterOption[],
  label: string
): (props: { column: MRTColumn<PermissionsByGranteeId>; table: MRTTableInstance<PermissionsByGranteeId> }) => AutocompleteProps<FilterOption, false, false, false, "div"> {
  const [inputValue, setInputValue] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();

  return ({ column }) => {
    const filterValue = column.getFilterValue() as string | undefined;
    const selectedOption = filterValue
      ? options.find((option) => option.value === filterValue) || null
      : null;

    return {
      value: selectedOption,
      inputValue: selectedOption?.label ?? inputValue,
      onInputChange: (_event, newInputValue, reason) => {
        if (reason === "clear") {
          column.setFilterValue(undefined);
          setInputValue("");
          const newSearchParams = new URLSearchParams(location.search);
          newSearchParams.delete(`${columnId}UserId`);
          navigate({ search: newSearchParams.toString() });
          return;
        }
        setInputValue(newInputValue);
      },
      onChange: (_event, selectedOption) => {
        if (!selectedOption) return;
        column.setFilterValue(selectedOption.value);
        setInputValue(selectedOption.label);
      },
      options,
      getOptionLabel: (option) =>
        typeof option === "string" ? option : option.label,
      isOptionEqualToValue: (option, value) =>
        option?.value === value?.value,
      renderInput: (params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Type to search"
          variant="outlined"
        />
      )
    } as AutocompleteProps<FilterOption, false, false, false, "div">;
  };
}
